//libs
import { styled } from '@nykaa/ui-components';

export const ParentContainer = styled.div`
  position: absolute;
  bottom: 8px;
  left: 8px;
`;

export const BadgeContainer = styled.div<{ borderColor: string; bgColor: string }>`
  background: ${({ bgColor }) => bgColor};
  width: fit-content;
  display: inline-block;
  padding: ${({ theme }) => theme.spacing.spacing10} ${({ theme }) => theme.spacing.spacing20};
  border-radius: ${({ theme }) => theme.borders.radius10};
  border-color: ${({ borderColor }) => borderColor};
  letter-spacing: 0.9px;
  margin-right: ${({ theme }) => theme.spacing.spacing20};
  ${({ theme }) => theme.typography.labelSmall};
`;

export const BadgeContent = styled.span<{ color: string }>`
  color: ${({ color }) => color};
  ${({ theme }) => theme.typography.labelSmall};
  margin: 0 auto;
  vertical-align: middle;
`;
